const SizeSelector = ({ sizes = [], value, onChange }) => {
  return (
    <div>
      <p
        style={{
          margin: "0px 0 6px 0px",
          fontWeight: 500,
          color: "#333",
        }}
      >
        Select Size
      </p>

      <div
        style={{
          display: "flex",
          gap: "0.7rem",
          marginLeft: "3px",
          flexWrap: "wrap",
        }}
      >
        {sizes.map((s) => {
          const selected = value === s;

          return (
            <button
              key={s}
              type="button"
              onClick={() => onChange({ target: { value: s } })}
              aria-label={`Select size ${s}`}
              aria-pressed={selected}
              style={{
                minWidth: "44px",
                height: "44px",
                padding: "0 12px",
                border: selected ? "2px solid #c62828" : "2px solid #e0e0e0",
                background: selected ? "#fff1f1" : "#fff",
                color: "#333",
                fontWeight: selected ? 700 : 600,
                borderRadius: "8px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: selected
                  ? "0 2px 8px rgba(211, 47, 47, 0.12)"
                  : "none",
                transition:
                  "border-color 0.2s, transform 0.15s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s, background 0.2s",
                transform: selected ? "scale(1.03)" : "scale(1)",
                zIndex: selected ? 1 : 0,
              }}
            >
              {s}
            </button>
          );
        })}
      </div>

      <p
        style={{
          margin: "0.5rem 0px 3px 0px",
          color: "#777",
        }}
      >
        True to size
      </p>
    </div>
  );
};

export default SizeSelector;
